<template>
  <div class="tableWithPerPageSelection">
    <a ref="lienDownload"></a>
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeRegroupementProduit.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button
                class="button is-addOrEdit"
                @click="checkPermissions(permCatalogue.maj)
                  ? $router.push({ name: 'm.bodac.catalogue-addEditRegroupementProduit' })
                  : showPopUp()"
                :class="{'button-access-no-permission': !checkPermissions(permCatalogue.maj)}">
                {{ $t('listeRegroupementProduit.actions.add')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options="actions"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllRegroupement().length > 0"
            />
          </div>
          <form
            @submit.prevent="recherche()"
            class="column is-5 pdr-0 pdl-0">
            <b-input
              v-model="allCriteresRecherche.auto"
              :placeholder="$t('listeProduitFace.actions.search')"
              type="search"
              icon="magnify">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label
                  :class="nombreCritere > 0 ? '' : 'is-invisible'"
                  class="has-text-weight-bold">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span
              @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permCatalogue.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      v-if="startArrayRendering"
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      url="">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox
          v-model="props.row.selected"
          :value="props.row">
        </b-checkbox>
      </div>
      <div slot="code" slot-scope="props">
        <router-link :to="{ name: 'c.bodac.catalogue-detailRegroupementProduit',
        params: {id: props.row.id}}" class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(permCatalogue.lecture)}">
          {{props.row.code}}
        </router-link>
      </div>
      <div slot="marche" slot-scope="props">
        <div>{{ props.row.marche ? props.row.marche.libelle : '' }}</div>
      </div>
      <div slot="fournisseur" slot-scope="props">
        <div>{{ getFournisseurs(props.row.marche) }}</div>
      </div>
      <div slot="edit" slot-scope="props">
        <router-link
          :to="{
            name: 'm.bodac.catalogue-addEditRegroupementProduit',
            params: { id: props.row.id }
          }">
          <b-icon
            icon="pencil-box-outline"
            type="is-success"
            :class="{'text-access-no-permission': !checkPermissions(permCatalogue.maj)}">
          </b-icon>
        </router-link>
      </div>
      <div slot="delete" slot-scope="props">
        <div
          @click="checkPermissions(permCatalogue.supprimer)
            ? openPopUpDelete(props.row) : showPopUp()"
          class="is-cursor-pointer">
          <b-icon
            type="is-danger"
            icon="delete-forever"
            :class="{'text-access-no-permission': !checkPermissions(permCatalogue.supprimer)}"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <div v-show="showFiltre" class="componentBrief">
      <filtre-regroupement-produit
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"
        ref="filtreRegroupementProduit"/>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :mess-header="$t('listeRegroupementProduit.popUpSuppression.title')"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="deleteRegroupement"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import Breadcrumb from '@/components/general/breadcrumb';
import SelecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import { SET_DETECT_CHANGE_SOCIETE } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import FiltreRegroupementProduit from '@/components/presse/regroupementProduit/filtreRegroupementProduit';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { deleteAsync } from '@/api/produit/regroupementProduit';
import PopUpPrevention from '@/components/general/popUpPrevention';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import messageSucces from '@/services/general/messageSucces';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_REGROUPEMENT_PRODUITS } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const RegroupementProduit = createNamespacedHelpers('regroupementProduit');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    Breadcrumb,
    SelecteurAction,
    TableItemsInView,
    FiltreRegroupementProduit,
    PopUpPrevention,
    exportExcelButton,
    parametrageTable,
  },
  data() {
    return {
      permCatalogue: CATALOGUE,
      affectations: [],
      unsubscribeValue: null,
      startArrayRendering: false,
      showFiltre: false,
      popUpSuppression: false,
      regroupementProduitId: null,
      resultPerPage: RESULTS_PER_PAGE,
      referenceTable: REFERENCE_TABLE_REGROUPEMENT_PRODUITS,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...RegroupementProduit.mapGetters({
      items: 'items',
      total: 'total',
      allCriteresRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeRegroupementProduit.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeRegroupementProduit.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    iconSelectTotal() {
      if (this.allRegroupement) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    allRegroupement() {
      return this.getAllRegroupement().length === this.items.length
        && this.items.length > 0;
    },
    nombreCritere() {
      const banCritereKey = ['auto'];
      const nbCritere = calculNombreCritere(this.allCriteresRecherche, banCritereKey);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = ['selected', 'code', 'libelle', 'marche', 'fournisseur', 'edit', 'delete'];
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$t('listeRegroupementProduit.tabs.code'),
          libelle: this.$t('listeRegroupementProduit.tabs.libelle'),
          marche: this.$t('listeRegroupementProduit.tabs.marche'),
          fournisseur: this.$t('listeRegroupementProduit.tabs.fournisseur'),
          edit: '',
          delete: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['code', 'libelle'],
        columnsClasses: {
          selected: 'colonneSelected',
          edit: 'colonneSelected',
          delete: 'colonneSelected',
        },
        requestFunction: ((data) => {
          data.query = cloneDeep(this.allCriteresRecherche);
          data.query.societeId = this.societeActiveId;
          return this.actionLoadItems(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.total,
          };
        }),
      };
    },
    actions() {
      return [];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...RegroupementProduit.mapActions({
      actionLoadItems: 'loadItems',
    }),
    getAllRegroupement() {
      return this.items.filter((el) => { return el.selected; });
    },
    handleAction(action) {
      switch (action) {
        default:
          messageErreur(this.$i18n, this.$t('general.noActionSelect'));
          break;
      }
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    selectAll() {
      const select = !this.allRegroupement;
      this.items.forEach((el) => {
        el.selected = select;
      });
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getFournisseurs(marche) {
      if (!marche?.commissions?.length) return '';
      return marche.commissions
        .map(el => el.fournisseur.nomCommercial)
        .join(', ');
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreRegroupementProduit.initializeFiltre();
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreRegroupementProduit.initializeFiltre();
      this.$refs.filtreRegroupementProduit.viderCritere();
      this.$refs.filtreRegroupementProduit.appliquerCritere();
      this.showFiltre = false;
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    openPopUpDelete(regroupementProduit) {
      this.regroupementProduitId = regroupementProduit.id;
      this.popUpSuppression = true;
    },
    async deleteRegroupement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await deleteAsync(this.regroupementProduitId);
        messageSucces(this.$t('listeRegroupementProduit.popUpSuppression.sucessDelete'));
        loadingComponent.close();
        this.popUpSuppression = false;
        this.regroupementProduitId = null;
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  goFirstPage() {
    this.$refs[this.referenceTable].setPage(1);
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageGescom.regroupementProduit.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
